// extracted by mini-css-extract-plugin
export default {"departments":"hG-z","departmentHeading":"iG-z","departmentSection":"jG-z","departmentName":"kG-z","departmentLink":"lG-z","expandIcon":"mG-z"};